import axios from "axios";
import { BASE_URL } from "../../constants/api-constants";

export const useApi = () => {
  const post = async (payload) => {
    const { route, access_token, ...rest } = payload;
    const config = { headers: { Authorization: `Bearer ${access_token}` } };
    try {
      const { data } = await axios.post(`${BASE_URL}/${route}`, rest, config);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const patch = async (payload) => {
    const { route, access_token, id, ...rest } = payload;
    const config = { headers: { Authorization: `Bearer ${access_token}` } };
    try {
      const { data } = await axios.patch(
        `${BASE_URL}/${route}/${id}`,
        rest,
        config
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getById = async (id, route) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/${route}/${id}`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getAll = async (route, query) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/${route}`, {
        params: query,
      });
      return data;
    } catch (error) {}
  };

  return { post, getById, getAll, patch };
};
